document.addEventListener('DOMContentLoaded', function () {
  // Native video modal
  let videoPosters = document.querySelectorAll('.videoposter[data-target="#video-popup"]');
  videoPosters.forEach(function (poster) {
    poster.addEventListener('click', function () {
      let videoTitle = poster.getAttribute('data-video');
      document.querySelector('#video-popup .video .mp4').src = '/wp-content/themes/dutch-search-awards/resources/assets/videos/video-aftermovie-' + videoTitle + '.mp4';
      document.querySelector('#video-popup .video .ogv').src = '/wp-content/themes/dutch-search-awards/resources/assets/videos/video-aftermovie-' + videoTitle + '.ogv';
      document.querySelector('#video-popup .video .webm').src = '/wp-content/themes/dutch-search-awards/resources/assets/videos/video-aftermovie-' + videoTitle + '.webm';
      let video = document.querySelector('#video-popup .video');
      video.load();
      video.play();
    });
  });

  // YouTube video modal
  let ytVideoPosters = document.querySelectorAll('.videoposter[data-target="#iframe-popup"]');
  ytVideoPosters.forEach(function (poster) {
    poster.addEventListener('click', function () {
      let videoUrl = poster.getAttribute('data-videourl');
      document.querySelector('#iframe-popup .video').src = videoUrl + '?autoplay=1';
    });
  });

  $('#video-popup').on('hidden.bs.modal', function () {
    let video = document.querySelector('#video-popup .video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });

  $('#iframe-popup').on('hidden.bs.modal', function () {
    let iframe = document.querySelector('#iframe-popup .video');
    if (iframe) {
      let src = iframe.src.replace('?autoplay=1', '');
      iframe.src = '';
      iframe.src = src;
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/modules/videos.js